// Sidebar menu order per portal, shared by the legacy NavBar and the new-style
// buildNavItems. Items are matched by their `sidebarItems` key. Keys not listed
// here are not expected to be enabled for that portal: if a PSP turns them on
// anyway they are appended at the bottom, keeping their declaration order.

export const DOCTOR_SIDEBAR_ORDER = [
  'homepage',
  'summary',
  'export',
  'agenda',
  'patients',
  'therapyDiary',
  'patientActivities',
  'enrollmentHub',
  'virtualMeetings',
  'echocardiographicRequests',
  'biologicalSamples',
  'survey',
  'contact',
  'documents',
  'myDocuments',
  'infoMaterials',
  'communications'
]

export const PATIENT_SIDEBAR_ORDER = [
  'homepage',
  'summaryPatient',
  'agenda',
  'performances',
  'therapyDiary',
  'analytics',
  'therapies',
  'materialRequests',
  'survey',
  'contact',
  'documents',
  'myDocuments',
  'infoMaterials',
  'communications'
]

export const INSURANCE_SIDEBAR_ORDER = [
  'homepage',
  'agenda',
  'performances',
  'therapyDiary',
  'analytics',
  'therapies',
  'survey',
  'contact',
  'documents',
  'myDocuments',
  'infoMaterials',
  'communications'
]

export const CLIENT_SIDEBAR_ORDER = [
  'homepage',
  'summary',
  'export',
  'customerUtilities',
  'medicalCenters',
  'documents',
  'myDocuments',
  'infoMaterials'
]

export function getSidebarOrder(userGroup?: string): string[] {
  const group = userGroup?.toUpperCase() ?? ''
  if (group.includes('INSURANCEUSER')) {
    return INSURANCE_SIDEBAR_ORDER
  }
  if (group.includes('PATIENT')) {
    return PATIENT_SIDEBAR_ORDER
  }
  if (group.includes('CLIENT')) {
    return CLIENT_SIDEBAR_ORDER
  }
  return DOCTOR_SIDEBAR_ORDER
}

export function sortBySidebarOrder<T extends {key: string}>(items: T[], userGroup?: string): T[] {
  const order = getSidebarOrder(userGroup)
  const rank = (key: string) => {
    const index = order.indexOf(key)
    return index === -1 ? order.length : index
  }
  return items
    .map((item, index) => ({item, index}))
    .sort((a, b) => rank(a.item.key) - rank(b.item.key) || a.index - b.index)
    .map(({item}) => item)
}
